// extracted by mini-css-extract-plugin
var _1 = "bff2b5";
var _2 = "a45085";
var _3 = "fde0b7";
var _4 = "ba5145";
var _5 = "ac7b4a";
var _6 = "ab5ee0";
export { _1 as "audio_player_control__button", _2 as "audio_player_control__button__active", _3 as "audio_player_control__button__bordered", _4 as "audio_player_control__button__disabled", _5 as "audio_player_control__button__image", _6 as "audio_player_control__hide_for_narrow" }
